import { PropsWithChildren, useRef } from 'react'

import { useCreation } from 'ahooks'

import { PreviewFile } from '@eastcoal/common/components/PreviewFile'
import { PreviewFileRef } from '@eastcoal/common/components/PreviewFile/interface'
import { RemoteTableStoreRef } from '@eastcoal/common/components/RemoteTable/Store/interface'

import { AuctionListStoreContext } from './contexts/StoreContext'
import { createAuctionListStore } from './store/createStore'

export const AuctionListStoreProvider = ({ children }: PropsWithChildren) => {
  const tableRef = useRef<RemoteTableStoreRef>(null)
  const previewRef = useRef<PreviewFileRef>(null)
  const store = useCreation(
    () => createAuctionListStore({ tableRef, previewRef }),
    []
  )

  return (
    <AuctionListStoreContext value={store}>
      {children}
      <PreviewFile ref={previewRef} />
    </AuctionListStoreContext>
  )
}
